var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "FieldInputNew", attrs: { id: _setup.field.name } },
    [
      _setup.INPUT_TEXT === _setup.field.type
        ? [
            _c(
              "div",
              { staticClass: "input-container" },
              [
                !_setup.field.usemask
                  ? [
                      _c("input", {
                        staticClass: "focusWhenEmpty",
                        class: { red: _setup.validLogic.red },
                        attrs: {
                          type: "text",
                          placeholder: _setup.field.placeholder,
                        },
                        domProps: { value: _setup.locval },
                        on: {
                          input: function ($event) {
                            return _setup.set_locval_delay($event.target.value)
                          },
                          blur: function ($event) {
                            return _setup.set_locval($event.target.value)
                          },
                        },
                      }),
                    ]
                  : [
                      _c(_setup.imaskInput, {
                        ref: "imaskComp",
                        staticClass: "focusWhenEmpty",
                        class: { red: _setup.validLogic.red },
                        attrs: {
                          placeholder: _setup.field.placeholder,
                          value: _setup.locval,
                          mask: _setup.field.usemask.mask,
                          lazy: _setup.field.usemask.lazy,
                          overwrite: _setup.field.usemask.overwrite,
                          unmask: true,
                        },
                        on: {
                          accept: _setup.set_locval_delay,
                          blur: _setup.set_locval_imaskComp,
                        },
                      }),
                    ],
                _vm._v(" "),
                _c("label", [_vm._v(_vm._s(_vm.title))]),
                _vm._v(" "),
                _setup.validLogic.hasError
                  ? _c("span", { staticClass: "error" }, [
                      _vm._v(_vm._s(_setup.validLogic.error)),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]
        : [_setup.INPUT_SELECT, _setup.INPUT_SELECTSEARCH].includes(
            _setup.field.type
          )
        ? [
            _c(
              "div",
              { staticClass: "custom-new-select" },
              [
                _c(_setup.MySelect, {
                  staticClass: "focusWhenEmpty",
                  class: { red: _setup.validLogic.red },
                  attrs: {
                    tabindex: "-1",
                    label: _vm.title,
                    list: _setup.options,
                    choosed: _setup.field.val,
                    onlyone: true,
                  },
                  on: { input: _setup.select },
                }),
                _vm._v(" "),
                _setup.validLogic.hasError
                  ? _c("span", { staticClass: "error" }, [
                      _vm._v(_vm._s(_setup.validLogic.error)),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _setup.INPUT_SELECTCHIPS === _setup.field.type
        ? [
            _c(
              "div",
              {
                staticClass: "custom-radio-container focusWhenEmpty",
                attrs: { tabindex: "-1" },
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "custom-radio-container__label",
                    class: { red: _setup.validLogic.red },
                  },
                  [_vm._v(_vm._s(_vm.title))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "custom-radio-container__options" },
                  _vm._l(_setup.options, function (option) {
                    return _c(
                      "span",
                      {
                        staticClass: "custom-radio-container__option",
                        class: { selected: _setup.selected(option) },
                        attrs: { tabindex: "0" },
                        on: {
                          click: function ($event) {
                            return _setup.set_field(option.id)
                          },
                        },
                      },
                      [_vm._v(_vm._s(option.name) + "\n                ")]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _setup.validLogic.hasError
                  ? _c("span", { staticClass: "error" }, [
                      _vm._v(_vm._s(_setup.validLogic.error)),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        : _setup.INPUT_DATE === _setup.field.type
        ? [
            _c(
              "div",
              {
                staticClass: "datepick-container",
                staticStyle: { position: "relative" },
              },
              [
                _c(_setup.DatePick, {
                  staticClass:
                    "datepick-container__input-container focusWhenEmpty",
                  class: { red: _setup.validLogic.red },
                  attrs: {
                    tabindex: "-1",
                    format: _setup.format,
                    nextMonthCaption: _setup.nextMonthCaption,
                    prevMonthCaption: _setup.prevMonthCaption,
                    setTimeCaption: _setup.setTimeCaption,
                    weekdays: _setup.weekdays,
                    months: _setup.months,
                    selectableYearRange: 99,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ toggle, inputValue }) {
                        return [
                          _c(_setup.imaskInput, {
                            ref: "imaskComp",
                            attrs: {
                              value: _setup.locval,
                              mask: Date,
                              lazy: _setup.isMaskLazy,
                              pattern: "d{.}`m{.}`Y",
                              unmask: true,
                              overwrite: true,
                            },
                            on: {
                              accept: _setup.set_locval_delay,
                              focus: toggle,
                              blur: _setup.set_locval_imaskComp,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "datepick-container__label",
                              class: { _active: _setup.isLabelActive },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.title) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _setup.date,
                    callback: function ($$v) {
                      _setup.date = $$v
                    },
                    expression: "date",
                  },
                }),
                _vm._v(" "),
                _setup.validLogic.hasError
                  ? _c("span", { staticClass: "error" }, [
                      _vm._v(_vm._s(_setup.validLogic.error)),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _setup.INPUT_TEXTAREA === _setup.field.type
        ? [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _setup.textarea,
                  expression: "textarea",
                },
              ],
              staticClass: "custom-textarea focusWhenEmpty",
              class: { red: _setup.validLogic.red },
              attrs: { tabindex: "-1", placeholder: _setup.field.placeholder },
              domProps: { value: _setup.textarea },
              on: {
                change: function ($event) {
                  return _setup.text_change($event.target.value)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _setup.textarea = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _setup.validLogic.hasError
              ? _c("span", { staticClass: "error" }, [
                  _vm._v(_vm._s(_setup.validLogic.error)),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }